import api from "./axios";

export async function getExamBases(filters = {}) {
    const {title, subjectId, pageNo = 1, pageSize = 20} = filters;

    const params = {};

    if (title && title.trim().length > 0) {
        params.title = title.trim();
    }

    if (subjectId !== undefined && subjectId !== null && subjectId !== "") {
        params.subjectId = Number(subjectId);
    }

    params.pageNo = pageNo;
    params.pageSize = pageSize;

    const res = await api.get("/exam-bases", {params});
    return res.data;
}

export async function getExamBaseById(id) {
    const res = await api.get(`/exam-bases/${id}`);
    return res.data;
}

export async function createExamBase(payload) {
    const body = {
        title: payload.title,
        defaultDurationMinutes: Number(payload.durationMinutes),
        defaultPassRate: Number(payload.passRate),
    };

    // Multi-topic templates: the full topic set (advanced flow). The wizard sends a single
    // subjectId instead; the backend treats it as a one-element set.
    if (Array.isArray(payload.subjectIds) && payload.subjectIds.length > 0) {
        body.subjectIds = payload.subjectIds.map(Number);
    }
    if (payload.subjectId !== undefined && payload.subjectId !== null && payload.subjectId !== "") {
        body.subjectId = Number(payload.subjectId);
    }

    // First-Exam Wizard tags the freshly-created template as an in-progress draft (1..4).
    if (payload.wizardStep !== undefined && payload.wizardStep !== null) {
        body.wizardStep = Number(payload.wizardStep);
    }

    const res = await api.post("/exam-bases", body);
    return res.data;
}

export async function updateExamBase(payload) {
    const body = {
        id: payload.id,
        title: payload.title,
        defaultDurationMinutes: Number(payload.durationMinutes),
        defaultPassRate: Number(payload.passRate),
    };

    // Multi-topic templates: when supplied, replaces the template's topic set. Omitted = unchanged.
    if (Array.isArray(payload.subjectIds) && payload.subjectIds.length > 0) {
        body.subjectIds = payload.subjectIds.map(Number);
    }

    const res = await api.put("/exam-bases", body);
    return res.data;
}

export async function deleteExamBase(id) {
    const res = await api.delete(`/exam-bases/${id}`);
    return res.data;
}

/**
 * One page of the students eligible for a template → {content, totalElements, totalPages, pageNo}.
 * Searched server-side across name and student number.
 */
export async function getExamBaseStudents(examBaseId, {pageNo = 1, pageSize = 20, search = ""} = {}) {
    const params = {pageNo, pageSize};
    if (search && search.trim().length > 0) params.search = search.trim();
    const res = await api.get(`/exam-bases/${examBaseId}/students`, {params});
    return res.data;
}

/** Numbers of every eligible student matching the search — for "select all matching". */
export async function getExamBaseStudentNumbers(examBaseId, {search = ""} = {}) {
    const params = {};
    if (search && search.trim().length > 0) params.search = search.trim();
    const res = await api.get(`/exam-bases/${examBaseId}/student-numbers`, {params});
    return res.data;
}

export async function assignQuestionsToExamBase(examBaseId, payload) {
    const res = await api.post(`/exam-bases/${examBaseId}/question-assignments`, payload);
    return res.data;
}

export async function duplicateExamBase(examBaseId) {
    const res = await api.post(`/exam-bases/${examBaseId}/duplicate`);
    return res.data;
}

export async function deleteQuestionFromExamBase(examBaseId, questionId) {
    const res = await api.delete(`/exam-bases/${examBaseId}/questions/${questionId}/unassign`);
    return res.data;
}

// --- First-Exam Wizard ---------------------------------------------------

// In-progress wizard drafts for the current tenant (templates with wizard_step set), newest first.
export async function getWizardDrafts() {
    const res = await api.get("/exam-bases/wizard-drafts");
    return res.data;
}

// Park a draft on a step (1..4), or pass null to clear the marker once the exam is published.
export async function updateExamBaseWizardStep(examBaseId, step) {
    const res = await api.patch(`/exam-bases/${examBaseId}/wizard-step`, {step});
    return res.data;
}